import { Util } from '@libs/utilities/util';

import { EnumSorting, EnumSortingDirection, ISortingOptions } from '../kw-workbench.interface';


export class SortingPipeHelper {


	processSorting(keywords: string[], originalText: string, option: ISortingOptions): string[] {

		//0 - is the formatting option valid?
		if (!Util.Enum.isValid(EnumSorting, option.sorting)) throw new Error(`SortingPipeHelper => processSorting => FATAL ERROR: the sorting of "${option.sorting}" is invalid (valid are: "${Util.Enum.values(EnumSorting).join(', ')}")`);
		if (!Util.Enum.isValid(EnumSortingDirection, option.sortingDirection)) throw new Error(`SortingPipeHelper => processSorting => FATAL ERROR: the sortingDirection of "${option.sortingDirection}" is invalid (valid are: "${Util.Enum.values(EnumSortingDirection).join(', ')}")`);

		//1 - sort the keywords, and apply sorting direction
		keywords = this.sort(keywords, originalText, option.sorting);
		keywords = this.sortingDirection(keywords, option.sortingDirection);

		//2 - return the sorted keywords
		return keywords;
	}


	/**------------------------------------------------------
	 * Sorting Functions
	 */
	private sort(keywords: string[], originalText: string, sorting: EnumSorting): string[] {

		switch (sorting) {
			case EnumSorting.KeepOriginal:
				return keywords;

			case EnumSorting.Alphabetic:
				return Util.Text.sortAlphabeticAsc(keywords);

			case EnumSorting.Occurrence:
				return this.sortByOccurrenceAsc(keywords, originalText);

			case EnumSorting.CharacterLength:
				return Util.Keywords.sortByLengthAsc(keywords);

			case EnumSorting.RandomShuffle:
				return Util.Keywords.shuffle(keywords);

			default:
				throw new Error(`SortingPipeHelper => sort => FATAL ERROR: sorting behavior of "${sorting}" is not defined`);
		}
	}

	private sortingDirection(keywords: string[], sortingDirection: EnumSortingDirection): string[] {

		switch (sortingDirection) {
			case EnumSortingDirection.Ascending:
				return keywords;

			case EnumSortingDirection.Descending:
				return keywords.reverse();

			default:
				throw new Error(`SortingPipeHelper => sortingDirection => FATAL ERROR: sortingDirection behavior of "${sortingDirection}" is not defined`);
		}
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private sortByOccurrenceAsc(keywords: string[], originalText: string): string[] {

		//0 - count the occurrences
		const mappedOccurrences: any = {};
		for (const keyword of keywords) {

			//a. count the occurrences
			const textOccurrence	: number = Util.Text.countOccurrence(originalText.toLowerCase(), keyword.toLowerCase());
			const keywordsOccurrence: number = keywords.filter((elem: string) => elem === keyword).length;

			//b. prepare structure for sorting
			mappedOccurrences[keyword] = textOccurrence + keywordsOccurrence;
		}

		//1 - sort by the occurrences
		const sortedKeywords: string[] = Object.keys(mappedOccurrences).sort((a: string, b: string) => mappedOccurrences[b] - mappedOccurrences[a]);
		return sortedKeywords;
	}
}
